export class ListFormatter {
  static format(items: string[], conjunction: string = '&'): string {
    const length = items.length;

    if (length === 0) return '';
    if (length === 1) return items[0];
    if (length === 2) return `${items[0]} ${conjunction} ${items[1]}`;

    const allButLast = items.slice(0, -1).join(', ');
    const lastItem = items[length - 1];
    return `${allButLast} ${conjunction} ${lastItem}`;
  }
}
